import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-reserve_btn_close",
  "use": "icon-reserve_btn_close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-reserve_btn_close\"><clipPath id=\"icon-reserve_btn_close_a\"><path d=\"m0 0h24v24h-24z\" /></clipPath><g clip-path=\"url(#icon-reserve_btn_close_a)\"><path d=\"m12 22c5.5 0 10-4.5 10-10s-4.5-10-10-10-10 4.5-10 10 4.5 10 10 10z\" fill=\"#fff\" /><g fill=\"#666\"><path d=\"m9 16c-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4l6-6c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-6 6c-.2.2-.4.3-.7.3z\" /><path d=\"m15 16c-.3 0-.5-.1-.7-.3l-6-6c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l6 6c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/reserve_btn_close.svg
// module id = wUAm
// module chunks = 87